import type { PassengerPricing, PricePassengerGroup } from '@massilia/queries'

/** Singular passenger type labels (e.g. price recap, sidebar) */
export const PASSENGER_TYPE_LABELS = {
  Adult: 'Adulte',
  Child: 'Enfant',
  Infant: 'Bébé',
  Senior: 'Senior',
  Youngster: 'Jeune',
} satisfies Record<PassengerPricing['type'], string>

/** Plural passenger type labels (e.g. conditions modal) */
export const PASSENGER_TYPE_LABELS_PLURAL = {
  Adult: 'Adultes',
  Child: 'Enfants',
  Infant: 'Bébés',
} satisfies Record<PricePassengerGroup['type'], string>
